import React from 'react'

import { CartConsumer } from 'context/CartContext'

export default WrappedComponent => props => (
  <CartConsumer>{cartState => <WrappedComponent {...props} {...cartState} />}</CartConsumer>
)
